import IPayload from "../interfaces/IPayload";
import IGenericMotivoResult from "../interfaces/IGenericMotivoResult";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";
class MotivoMovimentacaoInstalacaoService {
    async getById(id: string) {
        return await api.get<any>(`${resources.rebalanceMotivoMovimentacaoInstalacao}/GetById/${id}`);
    }

    async create(data: any) {
        return await api.post<any>(`${resources.rebalanceMotivoMovimentacaoInstalacao}/Create`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.rebalanceMotivoMovimentacaoInstalacao}/Update`, data);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.rebalanceMotivoMovimentacaoInstalacao}/Delete`, id);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.rebalanceMotivoMovimentacaoInstalacao}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getMotivos() {
        return await api.get<IGenericMotivoResult[]>(`${resources.rebalanceMotivoMovimentacaoInstalacao}/GetAllMotivos`);
    }
}

export default new MotivoMovimentacaoInstalacaoService();
